import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import StepInput from "./StepInput";
import StepReview from "./StepReview";
import StepBackTest from "./StepBackTest";
import Stepper from "../../../components/Stepper/Stepper";
import "./new-pricing.style.scss";
import { convertFormToPayload, DATE_FORMAT } from "./helper";
import * as Http from "../../../http";
import moment from "moment";
import dataSample from "../dataSample";

class NewPricing extends Component {
  state = {
    step: 1,
    formValues: {},
    backTestData: {},
    wasDataLoaded: false,
    loading: false,
    errorMessage: "",
    prefillData: {},
  };

  componentDidMount() {
    console.log(dataSample);
    const customerName = new URLSearchParams(this.props.location.search).get(
      "customerName",
    );
    const bankType =
      new URLSearchParams(this.props.location.search).get("bankType") || "";
    const sampleObj = dataSample[customerName] || {};
    const prefillData =
      (this.props.location.state || {}).prefillData ||
      JSON.parse(sessionStorage.getItem("pricingPrefillData") || "{}");
    sessionStorage.removeItem("pricingPrefillData");
    this.setState({
      formValues: { ...sampleObj, ...prefillData },
      wasDataLoaded: true,
      customerName: customerName,
      bankType: bankType,
      prefillData: prefillData,
    });
  }
  handleNextToPreview = (values) => {
    const params = new URLSearchParams(this.props.location.search);
    const customerName = params.get("customerName");
    const type = params.get("type") || "retail";
    const bankType = params.get("bankType") || "";

    const payloadValue = {
      ...values,
      customer_name:
        customerName ||
        values.customer_name ||
        this.state.prefillData.customer_name ||
        "",
      customer_type: type === "retail" ? "Retail" : "Corporate",
    };
    const payload = convertFormToPayload(payloadValue, type);

    this.setState({ loading: true, errorMessage: "" });

    const trySave = (sendFn) =>
      sendFn(payload)
        .then((res) => {
          if (res.Success) {
            return Http.calPricing({
              customer_id: payloadValue.customer_id,
              customer_type: payloadValue.customer_type,
              process_date: moment().format(DATE_FORMAT),
              bank_type: bankType,
            }).then((calRes) => {
              if (calRes.Success) {
                this.setState({
                  formValues: payloadValue,
                  step: 2,
                  backTestData: calRes.Data,
                  loading: false,
                });
              } else {
                this.setState({
                  loading: false,
                  errorMessage: "Calculation failed. Please try again.",
                });
              }
            });
          } else if (res.ErrorCode === 701 && sendFn === Http.sendPricing) {
            // Entry already exists today → retry with update
            return trySave(Http.sendUpdatePricing);
          } else if (
            res.ErrorCode === 702 &&
            sendFn === Http.sendUpdatePricing
          ) {
            // Entry does not exist yet → retry with create
            return trySave(Http.sendPricing);
          } else {
            this.setState({
              loading: false,
              errorMessage:
                res.Message || `Error: ${res.ErrorCode || "Unknown error"}`,
            });
          }
        })
        .catch((err) => {
          this.setState({
            loading: false,
            errorMessage: "Network error. Please try again.",
          });
        });

    // Use PUT for existing pricing, POST for new pricing
    const sendFn =
      bankType === "existing" ? Http.sendUpdatePricing : Http.sendPricing;

    trySave(sendFn);
  };

  handleNextToBackTest = () => {
    this.setState({ step: 3 });
  };

  renderStep = () => {
    const params = new URLSearchParams(this.props.location.search);
    const type = params.get("type") || "retail";
    switch (this.state.step) {
      case 1:
        return this.state.wasDataLoaded ? (
          <StepInput
            formValues={this.state.formValues}
            prefillData={this.state.prefillData}
            type={type}
            bankType={this.state.bankType}
            loading={this.state.loading}
            onSubmit={(values) => {
              this.handleNextToPreview(values);
            }}
            onPrev={() => {
              this.props.history.push("/pricing/processing");
            }}
          />
        ) : (
          <div></div>
        );
      case 2:
        return (
          <StepReview
            backTestData={this.state.backTestData}
            type={type}
            formValues={this.state.formValues || {}}
            onSubmit={() => {
              this.handleNextToBackTest();
            }}
            onPrev={() => {
              this.setState({ step: 1 });
            }}
          />
        );
      case 3:
        return (
          <StepBackTest
            backTestData={this.state.backTestData}
            onSubmit={() => {
              this.props.history.push("/pricing/processing");
            }}
            onPrev={() => {
              this.setState({ step: 2 });
            }}
          />
        );
      default:
        return null;
    }
  };
  render() {
    const params = new URLSearchParams(this.props.location.search);
    const type = params.get("type") || "retail";
    const customerName = params.get("customerName");
    const typeName =
      type === "retail" ? "Retail Customer" : "Corporate Customer";
    return (
      true && (
        <div className="new-container">
          <div className="header">
            <h4 className="title">PROCESSING</h4>
          </div>
          <div className="new-pricing-container">
            <Stepper
              activeStep={this.state.step}
              steps={[
                {
                  title: "Step 1",
                  description: "Input customer's information",
                },
                {
                  title: "Step 2",
                  description: "Pricing Estimation",
                },
                {
                  title: "Step 3",
                  description: "Proposed rate",
                },
              ]}
            />
            <div className="head">
              <p className="cus-name">
                {customerName} <span className="type-name">{typeName}</span>
              </p>
              <p className="process-date">
                Process date:{" "}
                <span className="process-date_date">
                  {moment().format(DATE_FORMAT)}
                </span>
              </p>
            </div>

            {this.state.errorMessage && (
              <div style={{ color: "red", margin: "8px 0", fontWeight: 500 }}>
                {this.state.errorMessage}
              </div>
            )}
            <div>{this.renderStep()}</div>
          </div>
        </div>
      )
    );
  }
}

export default withRouter(NewPricing);



// WEBPACK FOOTER //
// src/pages/Pricing/NewPricing/NewPricing.js